import { environment } from 'src/environments/environment';

export const DEFAULT_MIN_VALUE_CREDITS = 0;
export const DEFAULT_MIN_VALUE_REVIEWS = 0;
export const NUMBER_OF_ROUNDS = 2;
export const defaultCountry = 'Germany';
export const defaultState = 'Hamburg';
export const defaultGender = 'male';
export const WerderBremenCategoryTitle = 'WERDER Talent-Challenge';
export const THWChallengeTitle = 'THW TALENT CHALLENGE';
export const CoachChallengeTitle = 'COACH CHALLENGE GERMANY';
export const JunglowenChallengeTitle = 'JUNGLÖWEN CHALLENGE';
export const ProTHWChallengeTitle = 'PRO THW coming soon';

export enum Language {
  German = 'de',
  English = 'en',
}

export enum ProfileSegments {
  PersonalDetails = 'personalDetails',
  Experience = 'experience',
  Career = 'career',
  WerderBremen = 'werderBremen',
}

export enum MenuType {
  IOS = 'ios',
  ANDROID = 'android',
}

export const BaseWebSite = environment.production
  ? 'https://ukixx.viperdev.io'
  : window.location.origin;

export const AppStoreLinks = {
  ios: 'https://apps.apple.com/de/app/uleagz/id1531582115',
  android: 'https://play.google.com/store/apps/details?id=com.uleagz',
  web: 'https://uleagz.com/',
};

export const ChallengeTitles: Array<{ name: string; cssClass: string }> = [
  { name: WerderBremenCategoryTitle, cssClass: 'werder_bremen' },
  { name: THWChallengeTitle, cssClass: 'thw_challenge' },
  { name: CoachChallengeTitle, cssClass: 'coach_challenge_germany' },
  { name: JunglowenChallengeTitle, cssClass: 'junglowen' },
  { name: ProTHWChallengeTitle, cssClass: 'thw_pro_challenge' },
];
